import { HttpErrorResponse } from '@angular/common/http'
import { Update } from '@ngrx/entity'
import { createAction, props } from '@ngrx/store'
import { CategoriesEntity } from './categories.models'
import { ItemEntity } from 'libs/gb-front/selected-item/data-access/src/lib/+state/selected-item.models'

export const loadCategories = createAction('[Categories Page] Load Categories')

export const loadCategoriesSuccess = createAction(
  '[Categories/API] Load Categories Success',
  props<{ categories: CategoriesEntity[] }>(),
)

export const loadCategoriesFailure = createAction(
  '[Categories/API] Load Categories Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const updateSelectedCategoryUuid = createAction(
  '[Categories/API] Update Selected Category ID',
  props<{ uuid: string }>(),
)

export const updateCount = createAction('[Categories/API] Update Count', props<{ count: number }>())

export const syncCategory = createAction('[Categories/API] Sync Category', props<{ uuid: string }>())

export const updateCategory = createAction(
  '[Categories/API] Update Category',
  props<{ update: Update<CategoriesEntity> }>(),
)

export const addCategory = createAction('[Categories/API] Add Category', props<{ category: CategoriesEntity }>())

export const deleteCategory = createAction('[Categories/API] Delete Category', props<{ uuid: string }>())

export const resyncCategoryError = createAction(
  '[Categories/API] Resync Category Error',
  props<{ error: HttpErrorResponse; uuid?: string }>(),
)

export const resyncCategories = createAction('[Categories/API] Resync Categories', (offset: number) => ({ offset }))

export const resyncCategoriesOnScroll = createAction(
  '[Categories/API] Resync Categories On Scroll',
  (offset: number) => ({ offset }),
)

export const resyncCategoriesCurrentPage = createAction('[Categories/API] Resync Categories Current Page')

export const resyncCategoriesSuccess = createAction(
  '[Categories/API] Resync Categories Success',
  props<{
    categories: CategoriesEntity[]
    offset: number
    count: number
  }>(),
)

export const resyncCategoriesError = createAction(
  '[Categories/API] Resync Categories Error',
  props<{ error: HttpErrorResponse }>(),
)

// Stale actions
export const setAllCategoriesStale = createAction('[Categories] Set All Categories Stale')

export const removePageFromStale = createAction('[Categories] Remove Page From Stale', props<{ page: number }>())

export const categoryItemPreviewUpdate = createAction(
  '[Categories/API] Category Item Preview Update',
  props<{ item: ItemEntity }>(),
)

export const categoryItemPreviewDeleteItem = createAction(
  '[Categories/API] Category Item Preview Delete Item',
  props<{ itemUuid: string }>(),
)
